import axios, { AxiosInstance } from 'axios';
import {
  apiBlobStorageURL,
  mockAndDevelopment,
  productive,
} from 'src/app.config';

const blobStorageClient: AxiosInstance =
  productive() && mockAndDevelopment()
    ? axios.create()
    : axios.create({
        baseURL: apiBlobStorageURL(),
        headers: {
          accept: '*/*',
          contentType: 'application/json',
        },
        paramsSerializer: {
          indexes: null,
        },
      });

export default blobStorageClient;
